export const fetchPayHistory = async (sessionId: string, fromDate: string, toDate: string, page: number) => {
	try {
		const formData = new FormData();

		formData.append('method', 'get_pay_log');
		formData.append('start_date', fromDate);
		formData.append('end_date', toDate);
		formData.append('page_number', page.toString());
		formData.append('per_page', '10');
		formData.append('session_id', sessionId);

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
